import { render } from "./index.vue?vue&type=template&id=3a97643a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3a97643a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a97643a"]])

export default __exports__